// extracted by mini-css-extract-plugin
export default {"legend":"Legend-module__legend___qRSo8","legendItem":"Legend-module__legendItem___s2eVV","legendItemIcon":"Legend-module__legendItemIcon___hS5ex"};